import React, { useRef, useState, useEffect } from 'react';
import { useMediaQuery } from 'react-responsive';
import MenuIcon from '@mui/icons-material/Menu';
import CloseIcon from '@mui/icons-material/Close';
import { useLocation, useNavigate } from 'react-router-dom';
import ArrowRightIcon from '@mui/icons-material/ArrowRight';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { useSelector } from 'react-redux';

import { NavbarWrapper } from './navbar.styled';
import LogoImg from '&assets/images/logo.png';
import { size } from '&assets/constants/responsiveness';
import SubmitButton from '../submitButton/submitButton.component';
import Container from '../container/container.component';
import { RootState } from '&store/store';

const Navbar = (props: any) => {
	const challenges = useSelector(
		(state: RootState) => state.challenges.challenges
	);
	const isMobile = useMediaQuery({ maxWidth: size.mobile });
	const isTablet = useMediaQuery({
		minWidth: size.mobile,
		maxWidth: size.tablet,
	});
	const [showNavbar, setShowNavbar] = useState(false);
	const [showSubmit, setShowSubmit] = useState(true);
	const navigate = useNavigate();
	const location = useLocation();

	const handleShowNavbar = () => {
		setShowNavbar(!showNavbar);
	};

	useEffect(() => {
		window.scrollTo(0, 0);
		if (location?.pathname === '/submit-challenge') {
			setShowSubmit(false);
		} else {
			setShowSubmit(true);
		}
	}, [location.pathname]);

	const ref = useRef<any>(null);

	return (
		<NavbarWrapper ref={ref} showNavbar={true}>
			<Container>
				<div className="container">
					<button className="logo" onClick={() => navigate('/')}>
						{isMobile ? (
							<img src={LogoImg} alt="logo" height="30px" />
						) : (
							<img src={LogoImg} alt="logo" height="47.27px" />
						)}
					</button>
					<div className="mobile-menu">
						<div className="menu-icon" onClick={handleShowNavbar}>
							{showNavbar ? (
								<CloseIcon fontSize="large" htmlColor="white" />
							) : (
								<MenuIcon fontSize="large" htmlColor="white" />
							)}
						</div>
					</div>
					<div className={`nav-elements  ${showNavbar && 'active'}`}>
						<div className="tabs">
							<div
								onClick={() => {
									isMobile && setShowNavbar(false);
									navigate('/');
								}}
								className={`menu`}
							>
								<p className="links">Home</p>
							</div>
							<div
								onClick={() => {
									isMobile && handleShowNavbar();
									navigate('/about-us');
								}}
								className={`menu`}
							>
								<p className="links">About Us</p>
							</div>
							<div className="menu">
								<div className="dropdown-menu">
									<p className="links">
										<span>Challenges</span>
										<span className="dropdown-icon">
											<ArrowDropDownIcon />
										</span>
									</p>
									<div className="dropdown-content">
										<span
											onClick={() => {
												isMobile && handleShowNavbar();
												navigate('/challenges/current');
											}}
											className="archives"
										>
											Current Challenges
											{/* <ArrowRightIcon /> */}
										</span>
										{/* <span
											onClick={() => {
												isMobile && handleShowNavbar();
												navigate('/challenges/previous');
											}}
											className="archives"
										>
											Archive <ArrowRightIcon />
										</span> */}
									</div>
								</div>
							</div>
							{/* <div className="menu">
								<div className="dropdown-menu">
									<p className="links">
										<span>Programs</span>
										<span className="dropdown-icon">
											<ArrowDropDownIcon />
										</span>
									</p>
									<div className="dropdown-content">
										<span>Technical Workshops</span>
										<span className="archives">Educational Programs</span>
									</div>
								</div>
							</div> */}
							<div
								onClick={() => {
									isMobile && handleShowNavbar();
									navigate('/faq');
								}}
								className={`menu`}
							>
								<p className="links">FAQs</p>
							</div>

							{/* {(isMobile || isTablet) && (
								<div className={`menu`}>
									{showSubmit && (
										<SubmitButton
											id="apply-now-challenge-btn"
											title="APPLY NOW "
											handleClick={() => {
												isMobile && setShowNavbar(false);
												navigate('/submit-challenge');
											}}
											className="submit-challenge"
											icon={true}
										/>
									)}
								</div>
							)} */}
						</div>
					</div>
					{/* {!isMobile && !isTablet && (
						<div className={`menu`}>
							{showSubmit && (
								<SubmitButton
									id="apply-now-challenge-btn"
									title="APPLY NOW "
									handleClick={() => {
										isMobile && setShowNavbar(false);
										navigate('/submit-challenge');
									}}
									className="submit-challenge"
									icon={true}
								/>
							)}
						</div>
					)} */}
				</div>
			</Container>
		</NavbarWrapper>
	);
};

export default Navbar;
